import { render, staticRenderFns } from "./SitesAccount.vue?vue&type=template&id=8087d4ea&"
import script from "./SitesAccount.vue?vue&type=script&lang=js&"
export * from "./SitesAccount.vue?vue&type=script&lang=js&"
import style0 from "./SitesAccount.vue?vue&type=style&index=0&id=8087d4ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports